import { Avatar, Box, Checkbox, FormControlLabel, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Tooltip, Typography, useTheme, Grid, Button, Divider, Select, MenuItem } from "@mui/material"
import { useTaskContext } from "../../../../shared/context/taskContext"
import WidgetsIcon from '@mui/icons-material/Widgets';
import ThumbUpAltRoundedIcon from '@mui/icons-material/ThumbUpAltRounded';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import CloseIcon from '@mui/icons-material/Close';
import { useState, useEffect } from 'react';
import { useOt } from "../../../../shared/context/otContext"
import { useUtiles } from "../../../../shared/context/utilesContext"
import SelectResourceComponent from "./SelectResourceComponent"
import AddIcon from '@mui/icons-material/Add';
import CancelIcon from '@mui/icons-material/Cancel';
import InventoryIcon from '@mui/icons-material/Inventory';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

export default function InsumoReview() {
    const { taskByHash, updateTaskResource, loadingUpdateTaskResource, resourceSelected, setResourceSelected, isSelectResource, resetResourceSelected, handleAddResource, resourceNotRegister, setResourceNotRegister } = useTaskContext()
    const { ot } = useOt()
    const { openSilderWith, saveCurrentComponent, unitOptions } = useUtiles()

    

    const theme = useTheme()
    const [quantities, setQuantities] = useState(() => {
        const initialQuantities = {};
        taskByHash.resources.forEach(resource => {
            initialQuantities[resource.id_task_resource] = resource.quantity;
        });
        return initialQuantities;
    });
 
   





    const handleSelectResource = () => {
        openSilderWith(<SelectResourceComponent />, 600, 'Agregar insumo')
        saveCurrentComponent()
    }

    useEffect(() => {
        if (resourceNotRegister) {
            resetResourceSelected()
        }
    }, [resourceNotRegister])


    const handleChangeName = (e) => {
        if(resourceNotRegister){
            setResourceSelected({ ...resourceSelected, name_new: e.target.value })
        }else{
            setResourceSelected({ ...resourceSelected, name: e.target.value })
        }
    }


    return (
        <Box sx={{ p: 2 }}>

            {ot.status.name === "in_process" && <Box>
                <Typography variant="body1" sx={{ color: theme.palette.text.primary, fontSize: 16, fontWeight: 600 }}>
                    Agregar materiales o insumos a la tarea
                </Typography>

                <Box sx={{ mb: 0 }}>
                    <>
                        {!resourceNotRegister && !isSelectResource && <TextField onClick={handleSelectResource} variant="outlined" fullWidth value="Haga click para agregar insumos del inventario" type="text" slotProps={{
                            input: {
                                readOnly: true
                            }
                        }} />
                        }

                        {(resourceNotRegister || (isSelectResource && resourceSelected.name !== "")) && <Grid container spacing={1} columns={14}>
                           { resourceSelected.amount && <Grid item size={{ xs: 14 }}>
                                <Typography variant="body1" sx={{ color: theme.palette.warning.main, fontSize: 14, fontWeight: 600 }}>
                                    {resourceSelected.amount} {resourceSelected.unit}s en stock
                                </Typography>
                            </Grid>}
                            <Grid item size={{ xs: 14, md: 5.5 }}>
                                <TextField variant="outlined" fullWidth value={ resourceNotRegister ? resourceSelected.name_new : resourceSelected.name} onChange={(e) => handleChangeName(e)} type="text" slotProps={{
                                    input: {
                                        readOnly: !resourceNotRegister
                                    }
                                }} />
                            </Grid>
                            <Grid item size={{ xs: 4, md: 2.5 }}>
                                <TextField variant="outlined" fullWidth value={resourceSelected.quantity} onChange={(e) => setResourceSelected({ ...resourceSelected, quantity: e.target.value })} type="number" />
                            </Grid>
                            <Grid item size={{ xs: 4, md: 2.5}}>
                                <Select
                                    fullWidth
                                    value={resourceSelected.unit}
                                    onChange={(e) => setResourceSelected({ ...resourceSelected, unit: e.target.value })}
                                    disabled={!resourceNotRegister}
                                    sx={{
                                        width: '100px'
                                    }}
                                >
                                    {unitOptions.map((unit) => (
                                        <MenuItem key={unit.value} value={unit.value}>{unit.label}</MenuItem>
                                    ))}
                                </Select>
                            </Grid>
                            <Grid item size={{ xs: 6, md: 3 }}>
                                <Box sx={{ display: 'flex', gap: 0.5, justifyContent: 'center', alignItems: 'center', width: '100%', height: '100%' }}>
                                    <Tooltip title="Agregar">
                                        <IconButton
                                            color="primary"
                                            onClick={handleAddResource}
                                            disabled={(resourceNotRegister ? resourceSelected.name_new === "" : resourceSelected.name === "") || resourceSelected.amount === 0 || parseFloat(resourceSelected.quantity) === 0 || parseFloat(resourceSelected.quantity) > parseFloat(resourceSelected.amount) || parseFloat(resourceSelected.quantity) < 0 || (!resourceSelected.unit && resourceNotRegister)}
                                            sx={{
                                                backgroundColor: theme.palette.primary.main,
                                                color: '#fff',
                                                borderRadius: '20%',
                                                p: 1.5,
                                                boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.15)',
                                                '&:hover': {
                                                    backgroundColor: theme.palette.primary.dark,
                                                    transform: 'translateY(-2px)',
                                                    transition: 'all 0.3s ease'
                                                }
                                            }}
                                        >
                                            <AddIcon sx={{ fontSize: 20, fontWeight: 600 }} />
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title="Cancelar">
                                        <IconButton
                                            color="error"
                                            onClick={() => {
                                                setResourceNotRegister(false)
                                                resetResourceSelected()
                                            }}

                                            sx={{
                                                backgroundColor: theme.palette.error.light,
                                                color: '#fff',
                                                borderRadius: '20%',
                                                p: 1.5,
                                                boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.15)',
                                                '&:hover': {
                                                    backgroundColor: theme.palette.error.main,
                                                    transform: 'translateY(-2px)',
                                                    transition: 'all 0.3s ease'
                                                }
                                            }}
                                        >
                                            <CloseIcon sx={{ fontSize: 20, fontWeight: 600 }} />
                                        </IconButton>
                                    </Tooltip>
                                </Box>
                            </Grid>
                        </Grid>
                        }
                    </>

                </Box>

                <FormControlLabel
                    control={
                        <Checkbox
                            checked={resourceNotRegister || false}
                            onChange={(e) => setResourceNotRegister(e.target.checked)}
                            sx={{ '&.Mui-checked': { color: theme.palette.primary.main } }}
                        />
                    }
                    label={
                        <Typography variant="body1" sx={{ color: theme.palette.text.primary, fontSize: 14, fontWeight: 600 }}>
                            Agregar insumo no registrado en el inventario
                        </Typography>
                    }
                />

                
            </Box>}


            <Divider sx={{ my: 2 }} />
            {
                taskByHash.resources.length > 0 ? (
                    <Box sx={{ mt: 3 }}>
                        <Typography variant="body1" sx={{ color: theme.palette.text.primary, fontSize: 16, fontWeight: 600 }}>Insumos usados en la tarea</Typography>
                        <Typography variant="body1" sx={{ color: theme.palette.text.secondary, fontSize: 13 }}>
                            Los siguientes insumos han sido usados en la tarea:
                        </Typography>
                    </Box>
                ) : (
                    <Typography variant="body1" sx={{ color: theme.palette.text.secondary, fontSize: 14, fontWeight: 600 }}>
                        {ot.status.name === "in_process" ? "Aún no se han agregado insumos a la tarea" : "No hay insumos registrados en la OT"}
                    </Typography>
                )
            }

            {
                taskByHash.resources.length > 0 && (
                    <TableContainer>
                        <Table sx={{ minWidth: "100%" }}>
                            <TableHead>
                                <TableRow>
                                    <TableCell sx={{ fontWeight: 600 }}>Insumo</TableCell>
                                    <TableCell sx={{ fontWeight: 600 }}>Cantidad</TableCell>
                                    <TableCell sx={{ fontWeight: 600 }}>Registrado</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {
                                    taskByHash.resources.map((resource) => (
                                        <TableRow key={resource.id}>
                                            <TableCell sx={{ minWidth: 250 }}>{resource.name || resource.name_new}</TableCell>
                                            <TableCell sx={{ maxWidth: 120 }}>
                                                <Typography variant="body1" sx={{ fontWeight: 500 }}>
                                                    {resource.quantity} {resource.unit}
                                                </Typography>
                                            </TableCell>
                                            <TableCell>
                                                {resource.resource_not_register ? (
                                                    <Tooltip title="Insumo no registrado en inventario">
                                                        <IconButton
                                                            sx={{
                                                                bgcolor: theme.palette.warning.light,
                                                                color: 'white',
                                                                borderRadius: '12px',
                                                                padding: '8px',
                                                                '&:hover': {
                                                                    backgroundColor: theme.palette.warning.light,
                                                                    transform: 'translateY(-2px)',
                                                                    transition: 'all 0.3s ease'
                                                                }
                                                            }}
                                                            
                                                        >
                                                            <CancelIcon fontSize="small" />
                                                        </IconButton>
                                                    </Tooltip>
                                                ) : (
                                                    <Tooltip title="Insumo registrado en inventario">
                                                        <IconButton
                                                            sx={{
                                                                bgcolor: theme.palette.info.light,
                                                                color: 'white',
                                                                borderRadius: '12px',
                                                                padding: '8px',
                                                                '&:hover': {
                                                                    backgroundColor: theme.palette.info.light,
                                                                    transform: 'translateY(-2px)',
                                                                    transition: 'all 0.3s ease'
                                                                }
                                                            }}
                                                            
                                                        >
                                                            <CheckCircleIcon fontSize="small" />
                                                        </IconButton>
                                                    </Tooltip>
                                                )}
                                            </TableCell>
                                        </TableRow>
                                    ))
                                }
                            </TableBody>
                        </Table>
                    </TableContainer>
                )
            }


        </Box>
    )
}